import { createPortal } from "react-dom";
import { GamefiedVector } from "../../Resume/svgs/svgs";
import AddMore from "../../Resume/add_more/add_more";
import { CircularProgressbarWithChildren, buildStyles } from "react-circular-progressbar";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export default function TakeSkillTestModal(props) {
  const navigate = useNavigate();
  const handleTakeTest = () => {
    navigate(`/user/job/skillTest/${props.indeed?.custom_name}`);
    props.handleClose();
  }

  return (
    <div>
      {
        createPortal(
          <div onClick={props.handleClose} className="fixed top-0 left-0 bottom-0 right-0 z-10 bg-tet-600 overflow-y-scroll min-h-screen py-7 backdrop-blur-[2px] flex justify-center items-center">
            <section onClick={(e) => e.stopPropagation()} className="bg-white sm:max-w-[500px] min-w-[350px] w-[80%] z-100 m-auto rounded-[24px] pb-5 overflow-hidden relative">
              <div className="w-full max-w-[660px] p-4 flex justify-between items-center bg-[#5843BD] border-b-8 border-[#E9F1FF] rounded-tr-[24px] rounded-tl-[24px] ">
                <p className=" text-lg font-medium leading-normal text-left text-white">
                  Take Skill Test
                </p>
                {/*                 <div className="w-[64px] bg-[#F5F9FF] rounded-[50%] h-[64px] font-semibold">
                  <CircularProgressbarWithChildren
                    value={profile.message?.CompletionPercentage}
                    styles={buildStyles({
                      // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                      strokeLinecap: 'round',
                      // How long animation takes to go from one percentage to another, in seconds
                      pathTransitionDuration: 0.5,
                      // Can specify path transition in more detail, or remove it entirely
                      // pathTransition: 'none',
                      // Colors
                      pathColor: profile.message?.CompletionPercentage < 50 ? '#FF6633' : `#5843BD`,

                      trailColor: '#FFFFFF80',
                    })}
                  >
                    <p className="text-[20px] text-[#000000DE]">{profile.message?.CompletionPercentage}%</p>
                  </CircularProgressbarWithChildren>
                </div> */}

                <div className="w-8 h-8 cursor-pointer rounded-full bg-[#fff] flex justify-center items-center font-bold text-[#1C1C1C] text-opacity-60 text-[20px]" onClick={() => props.handleClose()}>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.2103 1.14844L1.14844 11.3612M1.14844 1.14844L11.2103 11.3612" stroke="black" strokeWidth="1.02128" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>

              {/* <div className="absolute top-[-8%] -z-10 left-[-30%]">
                <GamefiedVector />
              </div> */}

              <div className="flex flex-col items-center relative z-[1000] justify-center gap-y-4">
                <div className="px-4 py-2 w-max gap-x-4 flex  items-center">
                  <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1717534408/thumbup_c26edw.png" />
                  <p className=" text-2xl font-semibold leading-normal text-center text-[#5843BD]">
                    You are almost there!
                  </p>
                  <img src="https://res.cloudinary.com/drlcisipo/image/upload/v1717534408/thumbup_c26edw.png" />
                </div>
                <p className=" text-base font-normal leading-[1.2] text-center max-w-[280px] sm:max-w-[400px]">
                  This job includes a <span className="text-[#5843BD]">skill test.</span><br />
                  <strong>Demonstrate Your Skills!</strong><br />
                  Taking this skill test can significantly enhance your chances of getting hired,
                  showcasing to employers that you are the ideal candidate for the position.
                </p>

                <div className="flex gap-x-4">
                  <button className="bg-[#5843BD] text-white px-4 py-2 rounded-md" onClick={handleTakeTest}>
                    Take Test
                  </button>

                </div>

              </div>

            </section>
          </div>, document.getElementById("modal")
        )
      }
    </div>
  )
}